import { AdCreative, AssetFileMetadata } from '../types/AmazonAds';

const DspAdCreativeUtils = {
    buildAssetFileMetadata: (type: string): AssetFileMetadata => {
        return {
            contentType: type,
            durationInSeconds: 0,
            extension: '',
            height: 0,
            width: 0,
            resolutionHeight: 0,
            resolutionWidth: 0,
            sizeInBytes: 0,
            audioSampleRateInHz: 0,
            aspectRatio: '',
        };
    },
    toDspAdCreative: async (creative: AdCreative): Promise<AdCreative> => {
        for (const asset of creative.assets) {
            if (asset.assetSubTypes === 'THIRD_PARTY_VAST_VPAID') {
                const metadata = DspAdCreativeUtils.buildAssetFileMetadata('video/mp4');
                const file = await DspAdCreativeUtils.fetchVastXML(asset.fileMetadata);
                if (!file) {
                    continue;
                }
                asset.fileMetadataObject = metadata;
                asset.url = file;
            } else if (asset.assetSubTypes !== 'THIRD_PARTY_DISPLAY') {
                const parsedMetadata: AssetFileMetadata = JSON.parse(asset.fileMetadata);
                asset.fileMetadataObject = parsedMetadata;
            } else {
                const metadata = DspAdCreativeUtils.buildAssetFileMetadata('HTML');
                asset.fileMetadataObject = metadata;
            }
        }

        return creative;
    },
    fetchVastXML: async (vastUrl: string) => {
        try {
            const response = await fetch(vastUrl);
            const xmlText = await response.text();
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlText, 'text/xml');
            // Extract the first MediaFile URL
            const mediaFile = xmlDoc.querySelector('MediaFile');
            if (mediaFile && mediaFile.textContent) {
                return mediaFile.textContent.trim();
            } else {
                return '';
            }
        } catch (err) {
            console.log('cannot parse the file');
            return '';
        }
    },
};

export default DspAdCreativeUtils;
